import REST, { FetchOptions, BaseRes } from "@/utils/REST";
import { GetServerSidePropsContext } from "next/types";
import { RequestFunctionParams } from "yapi-to-typescript";

enum RestType {
  Read = "read",
  Create = "create",
  Form = "form",
}

export default function request<TResponseData>(
  payload: RequestFunctionParams,
  options: FetchOptions["options"] = {},
  // 服务端发起请求时需要
  ctx?: GetServerSidePropsContext
): Promise<TResponseData> {
  return new Promise<TResponseData>((resolve, reject) => {
    // 请求地址
    const url = payload.path;

    // 具体请求逻
    const restMethod: RestType = {
      GET: RestType.Read,
      POST: RestType.Create,
      FORM: RestType.Form,
      DELETE: RestType.Read,
      PUT: RestType.Read,
      PATCH: RestType.Read,
      OPTIONS: RestType.Read,
      HEAD: RestType.Read,
    }[payload.hasFileData ? "FORM" : payload.method];

    if (!restMethod) {
      throw new Error(`unknown req method: ${payload.method}`);
    }

    if (!REST[restMethod]) {
      throw new Error(`no req method: ${payload.method}->${restMethod}`);
    }

    // get post form
    REST[restMethod]<BaseRes<TResponseData>>({
      url,
      data: payload.hasFileData ? (payload.getFormData() as any) : payload.data,
      options: {
        ...options,
        headers: {
          ...(payload.hasFileData
            ? {}
            : payload.requestBodyType === "json"
            ? { "Content-Type": "application/json; charset=UTF-8" }
            : payload.requestBodyType === "form"
            ? {
                "Content-Type":
                  "application/x-www-form-urlencoded; charset=UTF-8",
              }
            : {}),
        },
      },
      ctx,
    })
      .then((response) => {
        resolve(
          response != null && typeof response === "object"
            ? response.data
            : (response as any)
        );
      })
      .catch((error: Error) => {
        reject(error);
      });
  });
}
